import { useEffect } from "react";

interface SEOMetaProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
  ogUrl?: string;
  schemaData?: Record<string, unknown>;
}

export default function SEOMeta({
  title,
  description,
  keywords,
  canonicalUrl,
  ogTitle,
  ogDescription,
  ogType = "website",
  ogUrl,
}: SEOMetaProps) {
  const fullTitle = `${title} - 9170登录手机版入口`;

  useEffect(() => {
    document.title = fullTitle;
    updateMeta("description", description);
    if (keywords) updateMeta("keywords", keywords);
    if (canonicalUrl) updateLink("canonical", canonicalUrl);
    updateMeta("og:title", ogTitle || fullTitle);
    updateMeta("og:description", ogDescription || description);
    updateMeta("og:type", ogType);
    if (ogUrl) updateMeta("og:url", ogUrl);
    updateMeta("twitter:title", ogTitle || fullTitle);
    updateMeta("twitter:description", ogDescription || description);
  }, [fullTitle, description, keywords, canonicalUrl, ogTitle, ogDescription, ogType, ogUrl]);

  return null;
}

function updateMeta(name: string, content: string) {
  let el = document.querySelector<HTMLMetaElement>(`meta[name="${name}"], meta[property="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    if (name.startsWith("og:") || name.startsWith("twitter:")) {
      el.setAttribute("property", name);
    } else {
      el.setAttribute("name", name);
    }
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function updateLink(rel: string, href: string) {
  let el = document.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export function SchemaOrg({ data }: { data: Record<string, unknown> }) {
  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  );
}